<template>
  <div class="LabelManagement">
    <AppHeader>标签管理</AppHeader>
    <AppBox class="appBox" id="appBox">
      <div class="toolsBox">
        <el-button type="primary" plain @click="handleAddTag" v-show="permissionCode.has('research:tag:manager')"
        >新增标签
        </el-button>
        <el-button type="primary" plain @click="handleToTagAttributePage"
        >标签分类管理
        </el-button>
      </div>
      <TagList :maxHeight="maxHeight"></TagList>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import TagList from "@/pages/TagManagement/TagList.vue";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "LabelManagement",
  components: {TagList, AppBox, AppHeader},
  data() {
    return {
      maxHeight: null,
    };
  },
  computed: {
    ...mapState("teachingCenter", ["tagList", "isBack"]),
    ...mapState("user", ["permissionCode"]),
  },
  async mounted() {
    this.$nextTick(async () => {
      if (this.isBack) {
        await this.getTagValueList({
          page: this.tagList.page,
          size: this.tagList.size,
        });
      }
      this.setData({key: "isBack", value: false});
    });
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  },
  methods: {
    ...mapActions("teachingCenter", ["getTagValueList"]),
    ...mapMutations("teachingCenter", ["setData"]),
    handleToTagAttributePage() {
      this.$router.push(
          {
            name: "TagAttribute",
          },
          () => {
          }
      );
    },
    handleAddTag() {
      this.$router.push(
          {
            name: "AddTag",
            params: {
              type: "add",
            },
          },
          () => {
          }
      );
    },
    // 重置高度
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        if (el.offsetHeight <= 650) {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.4;
        } else {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.25;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.LabelManagement {
  .appBox {
    height: calc(100vh - 155px);
    min-height: 350px;

    .toolsBox {
      text-align: right;
      margin-bottom: 20px;
    }
  }
}
</style>
